import {TokenService} from '@/services/storage.service';
import VacancyService from '@/services/vacancy.service';

const state = {
    isAgreement: TokenService.getAgreement() || false,

    vacancyList: [],
    totalVacancy: 0,
    employeeByStaffList: [],
    totalEmployeeByStaff: 0,
    vacancyId: null,
    selectedVacancy: null,
    vacancyIdOK: null,
    selectedVacancyOK: null,
    selectedVacancyYes: null,
    selectedCandidate: null,
    arizaPdf: null,
    annuncementList: [],
    totalAnnuncement: 0,
    selectedAnnuncement: null,
    annuncementId: null,
    selectVacancyByuser: [],

};

const getters = {}
const actions = {
    async getEmloyeesByStaffId({commit}, data) {
        try {
            let res = await VacancyService.getEmployeeByStaff( data )
            await commit( 'setEmployeeByStaffId', res.data ? res.data : {list: [], total: 0} )
        } catch (e) {
            await commit( 'setEmployeeByStaffId', {list: [], total: 0} )
        }
    },

    async getVacancy({commit}, data) {
        try {
            let res = await VacancyService.getVacancy( data )
            await commit( 'setVacancy', res.data ? res.data : [] )
        } catch (e) {
            await commit( 'setVacancy', [] )
        }
    },


    async getAnnuncement({commit}, data) {

        try {
            let res = await VacancyService.getAnnoucement( data )
            await commit( 'setAnnuncement', res.data ? res.data : {list: [], total: 0} )
        } catch (e) {
            await commit( 'setAnnuncement', {list: [], total: 0} )
        }
    },

    async getById({commit}, data) {

        try {
            let res = await VacancyService.getById( data )
            await commit( 'setSelectedAnnuncement', res.data ? res.data : null )
        } catch (e) {
            await commit( 'setSelectedAnnuncement', null )
        }
    },
}


const mutations = {
    setVacancy(state, data) {
        state.vacancyList = data
    },
    setEmployeeByStaffId(state, data) {
        state.employeeByStaffList = data.list;
        state.totalEmployeeByStaff = data.total
    },
    setSelectedVacancy(state, vacancy) {
        state.vacancyId = vacancy.id
        state.selectedVacancy = vacancy
    },
    setSelectedVacancyOK(state, vacancy) {
        state.vacancyIdOK = vacancy.detail.id
        state.selectedVacancyOK = vacancy.detail
        state.selectedVacancyYes = vacancy.value
    },
    setSelectedCandidate(state, can) {
        state.selectedCandidate = can
    },
    setAnnuncement(state, data) {
        state.annuncementList = data.list;
        state.totalAnnuncement = data.total
    },
    setSelectedAnnuncement(state, data) {
        state.annuncementId = data.id
        state.selectedAnnuncement = data
    },


    setArizaPdf(state, data) {
        state.arizaPdf = data
    },
    setAgree(state) {
        state.isAgreement = true
        TokenService.setTestAgreement( true )
    }
}

export const vacancy = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
